var exports = {
  "kL": "Notifications.module__container___VzlGY0",
  "Wq": "Notifications.module__switchesContainer___VzlGY0",
  "_8": "Notifications.module__pushSection___VzlGY0",
  "Fm": "Notifications.module__pushHeading___VzlGY0",
  "p2": "Notifications.module__pushDescription___VzlGY0",
  "_j": "Notifications.module__pushButtons___VzlGY0",
  "zd": "Notifications.module__pushButton___VzlGY0",
  "Zo": "Notifications.module__pushButtonSecondary___VzlGY0",
  "pz": "Notifications.module__pushStatus___VzlGY0",
  "$r": "Notifications.module__pushList___VzlGY0",
  "MW": "Notifications.module__pushListItem___VzlGY0",
};

module.exports = exports;
